import { useSelector } from 'react-redux';
import { getKBBPromoAmount } from '~/selectors';

function useShowKBBPromo() {
  const kbbPromoAmount = useSelector(getKBBPromoAmount);

  return kbbPromoAmount !== 0;
}

export default useShowKBBPromo;
